/* eslint-disable eqeqeq */
import { createActions, Store } from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import strip_tags from 'Components/striptags'
import keyMirror from 'keymirror'
import moment from 'moment'
import 'moment/locale/da'
import _ from 'lodash'

export const STATE = new keyMirror({
  TAKING_INPUT: null,
  IS_SAVING: null,
  IS_REDIRECT: null,
  HOF_FAILED: null,
  HOF_SUCCESS: null,
  FETCHING_HOFLIST: null,
  FETCHING_HOFLIST_FAILED: null,
  FETCHING_HOFLIST_SUCCESS: null,
  FETCHING_HOF: null,
  FETCHING_HOF_FAILED: null,
  HOF_DELETE_ERROR: null,
  HOF_DELETE_SUCCESS: null,
  FETCHING_GROUPS: null,
  FETCHING_GROUPS_FAILED: null,
  FETCHING_PREVIEW: null,
  FETCHING_PREVIEW_FAILED: null,
  FETCHING_HOF_ELEMENTS: null,
  FETCHING_HOF_ELEMENTS_FAILED: null,
  FETCHING_BRANDS_FAILED: null,
  ACTIVATE_HOF_SUCCESS: null
})

export const HofActions = createActions([
  'clearToast',
  'createEmptyHOF',
  'getHOFData',
  'getHOFDetails',
  'updateHOFField',
  'saveHOF',
  'deleteHOF',
  'getGroups',
  'toggleGroup',
  'previewHOF',
  'getHOFElements',
  'copyHOF',
  'toggleQueryContent',
  'getBrands',
  'giveAccess',
  'activateHOF',
  'toggleInActiveHof',
  'toggleActiveHof',
  'updateTranslations',
  'addTranslation',
  'fetchLanguages',
  'removeTranslation',
  'uploadLoginImageURL'
])

export class HofStore extends Store {
  constructor(props) {
    super(props)
    this.listenables = HofActions
    this.state = {
      status: null,
      filteredGroupData: [],
      hofDetails: {
        BrandID: '',
        moduleName: '',
        moduleDescription: '',
        moduleQuery: '',
        showProfileImages: 1,
        poolOrder: '',
        timeStart: moment().format('YYYY-MM-DD'),
        timeEnd: '',
        groups: [],
        groupFilterText: ''
      },
      hofList: [],
      groups: [],
      isPreview: false,
      previewElements: [],
      hofElements: [],
      isAdminAccess: false,
      fetchingBlogs: false,
      fetchingGroups: false,
      brands: [],
      HofFilterValue: 'active',
      showInactiveHof: false,
      showActiveHof: true,
      translations: [{ LanguageID: 1, moduleName: '', moduleDescription: '', bannerTitle: '', bannerDescription: '', bannerButtonText: '' }],
      languages: []
    }
  }
  clearToast(status) {
    status ? this.setState({ status }) : this.setState({ status: null })
  }
  createEmptyHOF() {
    this.setState({
      groups: [],
      isPreview: '',
      hofDetails: {
        BrandID: '',
        moduleName: '',
        moduleDescription: '',
        moduleQuery: '',
        showProfileImages: 1,
        poolOrder: '',
        timeStart: moment().format('YYYY-MM-DD'),
        timeEnd: '',
        groups: [],
        groupFilterText: ''
      },
      translations: [{ LanguageID: 1, moduleName: '', moduleDescription: '', bannerTitle: '', bannerDescription: '', bannerButtonText: '' }],
      languages: []
    })
  }

  getHOFData() {
    if (this.state.status === STATE.FETCHING_HOFLIST) {
      return false
    }
    this.setState({ status: STATE.FETCHING_HOFLIST })
    let api = this.state.isAdminAccess ? 'halloffame/admin-pool' : 'halloffame/pool'
    GET(api).then(responseJSON => {
      let nextState = {
        hofList: []
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_HOFLIST_FAILED
      } else {
        responseJSON = responseJSON.map(item => {
          if (item.moduleQuery && item.moduleQuery.length > 100) {
            item.moduleQueryReadMore = true
            item.moduleQueryReadLess = false
          } else {
            item.moduleQueryReadMore = false
            item.moduleQueryReadLess = false
          }
          return item
        })
        nextState.hofList = responseJSON
        nextState.status = STATE.FETCHING_HOFLIST_SUCCESS
      }
      this.setState(nextState)
    })
  }

  getHOFDetails(HalloffameID, copy) {
    this.setState({ status: STATE.FETCHING_HOF, isPreview: false })
    GET('halloffame/fetch-admin', { HalloffameID: HalloffameID }).then(responseJSON => {
      let nextState = {
        hofDetails: {},
        translations: [{ moduleName: '', moduleDescription: '', bannerTitle: '', bannerDescription: '', bannerButtonText: '' }]
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_HOF_FAILED
      } else {
        responseJSON.timeEnd = responseJSON.timeEnd && moment.parseZone(responseJSON.timeEnd).format('YYYY-MM-DD')
        responseJSON.timeStart = responseJSON.timeStart && moment.parseZone(responseJSON.timeStart).format('YYYY-MM-DD')
        this.getGroups(responseJSON.BrandID)
        this.fetchLanguages(responseJSON.BrandID)
        copy && delete responseJSON.HalloffameID
        responseJSON.showEntries = !responseJSON.showPoints
        responseJSON.useWallet = !responseJSON.useWalletActivation
        nextState.hofDetails = responseJSON
        nextState.status = STATE.TAKING_INPUT
        if (responseJSON.translations && responseJSON.translations.length) {
          nextState.translations = responseJSON.translations
        }
      }
      this.setState(nextState)
    })
  }
  getGroups(BrandID) {
    if (this.state.fetchingGroups) {
      return false
    }
    this.setState({ fetchingGroups: true })
    GET('groups/fetch-groups', { BrandID }).then(responseJSON => {
      let nextState = {
        groups: []
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_GROUPS_FAILED
      } else {
        nextState.groups = responseJSON
        ;(nextState.status = STATE.TAKING_INPUT), (nextState.fetchingGroups = false)
      }
      this.setState(nextState)
    })
  }

  fetchLanguages(BrandID) {
    Proxies.GET('schemas/languages').then(responseJSON => {
      if (!responseJSON.error) {
        Proxies.GET('brands/fetchBrandLanguages', { BrandID: BrandID }).then(langs => {
          if (!langs.error) {
            this.setState({ languages: responseJSON.filter(obj => langs.includes(obj.LanguageID)) })
          }
        })
      }
    })
  }
  updateHOFField(field) {
    let value = strip_tags(field.target.value)
    let hofDetails = this.state.hofDetails
    hofDetails[field.target.name] = value
    if (field.target.name === 'groupFilterText') {
      const groupsFilter = value ? this.state.groups.filter(item => item.moduleName.toLowerCase().includes(value.toLowerCase())) : this.state.groups
      this.setState({ filteredGroupData: groupsFilter })
    }
    if (field.target.name === 'timeStart') {
      value = moment.parseZone(value).format('YYYY-MM-DD')
    }
    if (field.target.name === 'timeEnd') {
      value = moment.parseZone(value).format('YYYY-MM-DD')
    }
    if (
      field.target.name === 'BrandID' ||
      field.target.name === 'poolOrder' ||
      field.target.name === 'showProfileImages' ||
      field.target.name === 'showCompanyName'
    ) {
      hofDetails[field.target.name] = Number(value)
    }
    if (field.target.name === 'BrandID') {
      this.getGroups(value)
    }
    if (field.target.name === 'showEntries') {
      hofDetails.showPoints = Number(!value)
      hofDetails[field.target.name] = Number(value)
      this.setState({ hofDetails })
    }
    if (field.target.name === 'showPoints') {
      hofDetails.showEntries = Number(!value)
      hofDetails[field.target.name] = Number(value)
      this.setState({ hofDetails })
    }
    if (field.target.name === 'useWalletActivation') {
      hofDetails.useWallet = Number(!value)
      hofDetails[field.target.name] = Number(value)
      this.setState({ hofDetails })
    }
    if (field.target.name === 'useWallet') {
      hofDetails.useWalletActivation = Number(!value)
      hofDetails[field.target.name] = Number(value)
      this.setState({ hofDetails })
    }
    this.setState({ hofDetails })
  }

  uploadLoginImageURL(data, name) {
    let file = data.target.files[0]
    Proxies.uploadImage(file).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        let hofDetails = this.state.hofDetails
        hofDetails[name] = responseJSON.imageOriginSource ? responseJSON.imageOriginSource : ''
        this.setState(hofDetails)
      }
    })
  }

  addTranslation() {
    this.setState({
      translations: [
        ...this.state.translations,
        { LanguageID: 1, moduleName: '', moduleDescription: '', bannerTitle: '', bannerDescription: '', bannerButtonText: '' }
      ]
    })
  }

  removeTranslation(index) {
    let translations = [...this.state.translations]
    translations.splice(index, 1)
    this.setState({ translations })
  }

  updateTranslations(fieldName, value, index) {
    this.setState({
      translations: this.state.translations.map((t, idx) => {
        if (idx === index) {
          t[fieldName] = value
        }
        return t
      })
    })
  }

  saveHOF() {
    this.setState({ status: STATE.IS_SAVING })
    let hof = this.state.hofDetails
    hof.BrandID === '' && delete hof.BrandID
    hof.poolOrder === '' && delete hof.poolOrder
    hof.showProfileImages === '' && delete hof.showProfileImages
    hof.showCompanyName === '' && delete hof.showCompanyName
    hof.useWalletActivation === '' && delete hof.useWalletActivation
    hof.usePoints === '' && delete hof.usePoints
    hof.translations = this.state.translations.filter(t => !!t.moduleName)
    if (!hof.bannerTextColor) {
      hof.bannerTextColor = '#000000'
    }

    !hof.ImageID && delete hof.ImageID
    POST('halloffame/replace', hof).then(responseJSON => {
      let nextState = {
        hofDetails: this.state.hofDetails
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATE.HOF_FAILED
        } else {
          nextState.hofDetails = responseJSON
          nextState.status = STATE.HOF_SUCCESS
        }
      }
      this.setState(nextState)
    })
  }

  deleteHOF(HalloffameID = null) {
    if (HalloffameID) {
      POST('halloffame/removeHof', { HalloffameID }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATE.HOF_DELETE_ERROR })
        } else {
          this.setState({ status: STATE.HOF_DELETE_SUCCESS })
        }
      })
    }
  }
  toggleGroup(checkbox) {
    let GroupID = checkbox.target.name
    let checked = checkbox.target.checked
    let hofDetails = this.state.hofDetails
    if (checked) {
      let thisGroup = this.state.groups.find(e => {
        return e.GroupID == GroupID
      })
      if (hofDetails.groups) {
        hofDetails.groups.push(thisGroup)
      } else {
        hofDetails.groups = [thisGroup]
      }
    } else {
      hofDetails.groups = hofDetails.groups.filter(e => {
        return e.GroupID != GroupID
      })
    }
    this.setState({ hofDetails: hofDetails })
  }

  previewHOF() {
    this.setState({ status: STATE.FETCHING_PREVIEW, isPreview: true })
    GET('halloffame/preview', { moduleQuery: this.state.hofDetails.moduleQuery }).then(responseJSON => {
      let nextState = {
        previewElements: this.state.previewElements,
        fetchingPreview: false
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_PREVIEW_FAILED
      } else {
        nextState.previewElements = responseJSON
        nextState.status = STATE.TAKING_INPUT
      }
      this.setState(nextState)
    })
  }

  getHOFElements(HalloffameID = null) {
    this.setState({ status: STATE.FETCHING_HOF_ELEMENTS })
    GET('halloffame/elements', { HalloffameID }).then(responseJSON => {
      let nextState = {
        hofElements: []
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_HOF_ELEMENTS_FAILED
      } else {
        nextState.hofElements = responseJSON
        nextState.status = STATE.TAKING_INPUT
      }
      this.setState(nextState)
    })
  }

  copyHOF(hof, props) {
    props.history.push(props.location.pathname + '/new?copy=' + hof.HalloffameID)
  }

  toggleQueryContent(e) {
    let hofList = this.state.hofList
    hofList = hofList.map(item => {
      if (item.HalloffameID === e.HalloffameID) {
        item.moduleQueryReadMore = !item.moduleQueryReadMore
        item.moduleQueryReadLess = !item.moduleQueryReadLess
      }
      return item
    })
    this.setState({ hofList })
  }

  getBrands() {
    this.setState({ fetchingBrands: true })
    GET('schemas/allbrands').then(responseJSON => {
      let nextState = {
        brands: []
      }
      if (responseJSON.error) {
        nextState.status = STATE.FETCHING_BRANDS_FAILED
      } else {
        nextState.brands = _.sortBy(responseJSON, 'brandName')
        nextState.status = STATE.TAKING_INPUT
      }
      this.setState(nextState)
    })
  }

  giveAccess(BrandID, fetchGroups) {
    if (fetchGroups) {
      let hofDetails = this.state.hofDetails
      hofDetails.BrandID = BrandID
      this.setState({ hofDetails, isAdminAccess: true })
      this.getGroups(hofDetails.BrandID)
    } else {
      this.setState({ isAdminAccess: true })
    }
  }

  activateHOF(HalloffameID = null) {
    if (HalloffameID) {
      POST('halloffame/enable', { HalloffameID }).then(responseJSON => {
        if (responseJSON.error) {
          this.setState({ status: STATE.HOF_DELETE_ERROR })
        } else {
          this.setState({ status: STATE.ACTIVATE_HOF_SUCCESS })
        }
      })
    }
  }

  toggleActiveHof() {
    let value = !this.state.showActiveHof ? 'active' : 'both'
    this.setState({ showActiveHof: !this.state.showActiveHof, HofFilterValue: value, showInactiveHof: false })
  }
  toggleInActiveHof() {
    let value = this.state.showInactiveHof ? 'both' : 'inactive'
    this.setState({ showInactiveHof: !this.state.showInactiveHof, HofFilterValue: value, showActiveHof: false })
  }
}
